import * as action_type from './../actions/userAuthentication/action_types';
import { connect } from 'react-redux';
import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import api from './../../lib/api';


function* getUserStatus(action) {
    try {
        const data = yield api.getUSerStatus(action.token);
        yield put({ type: action_type.API_USERAUTH_SUCCESS, data })
    }
    catch (e) {
        console.log(e);
    }
}

export const UserAuthSaga = [
    takeEvery(action_type.API_USERAUTH_FETCH, getUserStatus),

]


// WEBPACK FOOTER //
// ./src/redux/redux-saga/userAuthSaga.js